// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"18":"5aa8cb3a","23":"06a55035","172":"87979f26","234":"70e6491e","309":"29f4da2c","359":"4437a089","458":"04beeeb3","511":"5d27a8af","592":"cdc6de93","835":"77627a71","874":"2b460924","880":"eb916775","904":"ef60b4c1","933":"1d0547ec"}[chunkId] + ".chunk.js";
};